export default __webpack_public_path__ + "c4f6042abc62afe9fc94327f6c0cecd5.png";